import useSectionBreakpointStyles from 'EmailEditorUI/hooks/styleSettings/useSectionBreakpointStyles';
const useSectionSpacingCss = (section, selectable) => {
  const {
    marginBottom,
    marginTop,
    paddingBottom,
    paddingTop
  } = useSectionBreakpointStyles(section);
  if (!selectable || !section) {
    return {};
  }
  return Object.fromEntries(Object.entries({
    paddingTop,
    paddingBottom,
    marginTop,
    marginBottom
  }).filter(([, value]) => value && value !== '0px'));
};
export default useSectionSpacingCss;